<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Occupation
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeOccupationDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryOccupationFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryOccupationFilterForm"
                            v-model="filtersOccupation.occpDesc"
                            :label="filtersOccupationLabel.occpDesc"
                            :error-messages="errors.collect('filterOccupation')"
                            data-vv-name="filterOccupation"
                            :data-vv-as="filtersOccupationLabel.occpDesc"
                            v-validate="'entry|max:8'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearOccupationFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doOccupationFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="occupationHeaders"
          :items="occupationItems"
          v-bind:options.sync="paginationOccupation"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsOccupation"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.occp }}</td>
              <td>{{ row.item.occpDesc }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignOccupation(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersOccupationLabel: {
        occpDesc: 'Occupation'
      },
      filtersOccupation: {
        occpDesc: undefined
      },
      occupationItems: [],
      totalItemsOccupation: 0,
      occupationHeaders: [
        { text: 'Occupation', align: 'left', value: 'occp' },
        { text: 'Description', value: 'occpDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationOccupation: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearOccupationFilters()
  },
  methods: {
    closeOccupationDialog() {
      this.filtersOccupation.occpDesc = ''
      this.$emit('close')
    },
    doClearOccupationFilters() {
      this.filtersOccupation.occpDesc = null
      this.fetchOccupationData()
    },
    doOccupationFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryOccupationFilterForm').then((result) => {
        if (result) {
          this.paginationOccupation.page = 1
          this.fetchOccupationData()
        }
      })
    },
    assignOccupation(data) {
      // Use $emit to call parent page method assignOccupation and pass the value
      this.$emit('assign-occupation-info', data)
      this.$emit('assign-occupation', data.occpDesc)
      this.$emit('close')
    }
  },
  computed: {},
  watch: {
    'paginationOccupation': function (value) {
      this.fetchOccupationData()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
